import { useNavigation } from 'react-router';

export const useNavigationState = () => {
  const navigation = useNavigation();
  return {
    pageIdle: navigation.state === 'idle',
    pageLoading: navigation.state === 'loading',
  };
};
